// extracted by mini-css-extract-plugin
module.exports = {"scrolled":"Navbar_scrolled__pfO93","active":"Navbar_active__3_jpQ"};